import axios from 'axios';
import { PopupStoreItemCardType } from '../type';

interface GetArchivedPopupStoresArgs {
  page: number;
}

interface GetArchivedPopupStoresRes {
  popup_stores: PopupStoreItemCardType[];
}
export const getArchivedPopupStores = async (params: GetArchivedPopupStoresArgs) => {
  const { data } = await axios.get<GetArchivedPopupStoresRes>(`/${T.lang}/@api/next_popup_stores`, {
    params,
  });
  return data;
};

interface AddOpenRunListBody {
  popup_id: number;
  email: string;
}
export const addOpenRunList = async (body: AddOpenRunListBody) => {
  const { data } = await axios.post<GetArchivedPopupStoresRes>(`/${T.lang}/@api/add_open_run_list`, body);
  return data;
};
